module.exports = __webpack_public_path__ + "img/danmcgill-h-474x356.61e155a5.jpg";